var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgElectricity(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 44.718,
    viewBox: "0 0 50 44.718",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "electricity",
    transform: "translate(-94.168 -51.19)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_114",
    "data-name": "Path 114",
    d: "M143.444,87.9,123.792,53.86a5.339,5.339,0,0,0-9.248,0L94.891,87.9a5.339,5.339,0,0,0,4.624,8.009h39.305a5.34,5.34,0,0,0,4.624-8.009Zm-1.9,4.245a3.119,3.119,0,0,1-2.729,1.575H99.514a3.151,3.151,0,0,1-2.728-4.726l19.652-34.039a3.151,3.151,0,0,1,5.457,0l19.652,34.039a3.118,3.118,0,0,1,0,3.15Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_115",
    "data-name": "Path 115",
    d: "M299.638,167.15l-6.216,18.068,5.776-3.339-1,13.188,6.508-19.14-5.846,3.373Z",
    transform: "translate(-179.897 -105.317)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgElectricity);
export default __webpack_public_path__ + "static/media/electricity.ea7a29555af35804468e94d8501d0453.svg";
export { ForwardRef as ReactComponent };